import { includes } from "lodash";

export const NavItemType = {
  BrandItem: "brand_item",
  BrandSeriesItem: "brand_series_item",
  CatalogItem: "catalog",
  MenuGroup: "menu_group",
  MenuItem: "menu_item",
  PageItem: "page_item",
  ProductItem: "product",
  SinglePageMenuItem: "single_page_menu_item",
  ProductDiscountsItem: "product_discounts_item",
};

const availableMenuItemTypes = [
  NavItemType.BrandItem,
  NavItemType.BrandSeriesItem,
  NavItemType.CatalogItem,
  NavItemType.MenuGroup,
  NavItemType.MenuItem,
  NavItemType.PageItem,
  NavItemType.ProductItem,
  NavItemType.SinglePageMenuItem,
  NavItemType.ProductDiscountsItem,
];

/**
 * @param {NavigationItem} navItem
 * @return {boolean}
 */
export function isProcessableItem({ itemType }) {
  return includes(availableMenuItemTypes, itemType);
}

/**
 * @param {NavigationItem} navItem
 * @return {boolean}
 */
export function isClickableInMainMenu(navItem) {
  return navItem.itemType === NavItemType.SinglePageMenuItem || navItem.isLink;
}

/**
 * @param {NavigationItem} navItem
 * @return {boolean}
 */
export function isClickableInSidebarMenu(navItem) {
  return navItem.itemType === NavItemType.SinglePageMenuItem;
}

/**
 * @param {NavigationItem} navItem
 * @return {boolean}
 */
export function isMenuGroup(navItem) {
  if (navItem.itemType === NavItemType.MenuGroup) return true;
  return Boolean(navItem.hasItems && navItem.items && navItem.items.length);
}

/**
 * @param {NavigationItem} navItem
 * @return {boolean}
 */
export function isClickableInDropdown(navItem) {
  if (navItem.itemType === NavItemType.MenuGroup) return false;
  return navItem.isLink !== false;
}

/**
 * Поодинокі товари бренду (поза серіями) мають іти ДО груп, інакше вони
 * візуально приклеюються до попереднього заголовка серії й читаються як його частина.
 * @param {Array<NavigationItem>} items
 * @return {Array<NavigationItem>}
 */
export function orderedSubItems(items) {
  if (!items || !items.length) return [];
  return [...items.filter(item => !isMenuGroup(item)), ...items.filter(isMenuGroup)];
}

/**
 * @param {NavigationItem} navItem
 * @return {boolean}
 */
export function isNewProductsGroup(navItem) {
  return navItem.itemType === NavItemType.MenuGroup;
}

/**
 * @param {NavigationItem} navItem
 * @return {string}
 */
export function menuItemLabel(navItem) {
  const code = (navItem.subTitle || "").trim();
  return code ? `${code} – ${navItem.title}` : navItem.title;
}

/**
 * @param {NavigationItem} navItem
 * @param {NavigationItem|null} parentNavItem
 * @return {Object}
 */
export function routeForMenuItem(navItem, parentNavItem = null) {
  const { itemType, slug } = navItem;

  if (NavItemType.MenuGroup === itemType) {
    return { name: "products" };
  }

  if (parentNavItem) {
    if (slug === "seminars" && parentNavItem.slug === "education") {
      return { name: "training" };
    }

    if (parentNavItem.slug === "products") {
      if (slug === "catalog-discounts") {
        return {
          name: "products",
          query: { sort_filter_type: "with_promotions" },
        };
      }

      if (itemType === NavItemType.BrandItem) {
        return {
          name: "brand",
          params: { slug },
        };
      }
    }

    if (parentNavItem.itemType === NavItemType.BrandItem) {
      if (itemType === NavItemType.BrandSeriesItem) {
        // Серія тепер фільтр: ведемо на сторінку бренду з ?series=<slug>.
        return {
          name: "brand",
          params: { slug: parentNavItem.slug },
          query: { series: slug },
        };
      }
    }
  }

  if ([NavItemType.SinglePageMenuItem, NavItemType.PageItem].includes(itemType)) {
    if (slug === 'spivpracya') {
      return { name: 'collaboration', params: { slug } }
    }
    return { name: "page", params: { slug } };
  }
  if (NavItemType.ProductItem === itemType) {
    return { name: "card", params: { slug } };
  }
  if (NavItemType.CatalogItem === itemType || slug === "products") {
    return { name: "products" };
  }

  if (NavItemType.MenuItem === itemType && slug === "education") {
    return { name: "training" };
  }

  return { name: "page", params: { slug } };
}
